import { TableState, TableStateChangeFns } from "@/zustand/slices/tables";
import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

type PenaltyLeadsInPenaltyCalculationTablesState = Record<number, TableState>;

export type PenaltyLeadsInPenaltyCalculationTablesSlice = {
  penaltyLeadTables: PenaltyLeadsInPenaltyCalculationTablesState;
  addPenaltyLeadTable: (tableId: number) => void;
  getPenaltyLeadTableStateChangeFns: (
    tableId: keyof PenaltyLeadsInPenaltyCalculationTablesState
  ) => TableStateChangeFns;
};

const initialState: PenaltyLeadsInPenaltyCalculationTablesState = {};

const leadsInPenaltyCalculationTableState: TableState = {
  columnOrder: [
    "leadId",
    "product",
    "penaltyConditionName",
    "firstName",
    "lastName",
    "birthDate",
    "createdAt",
    "agent",
    "realizedAmount",
    "netoRealizedAmount",
    "currency",
    "realizedAt",
    "endDate",
    "partnerCommission",
    "penaltyCommission",
    "agentCode",
  ],
  columnWidths: [
    { columnName: "leadId", width: 150 },
    { columnName: "penaltyConditionName", width: 220 },
    { columnName: "firstName", width: 150 },
    { columnName: "lastName", width: 150 },
    { columnName: "birthDate", width: 200 },
    { columnName: "realizedAt", width: 200 },
    { columnName: "realizedAmount", width: 150 },
    { columnName: "currency", width: 150 },
    { columnName: "partnerCommission", width: 150 },
    { columnName: "penaltyCommission", width: 180 },
    { columnName: "endDate", width: 180 },
    { columnName: "createdAt", width: 200 },
    { columnName: "netoRealizedAmount", width: 200 },
    { columnName: "agent", width: 250 },
    { columnName: "product", width: 150 },
    { columnName: "agentCode", width: 250 },
  ],
  filters: [],
  grouping: [{ columnName: "penaltyConditionName" }, { columnName: "product" }],
  hiddenColumnNames: [],
  selection: [],
  sorting: [],
  search: "",
  expandedGroups: [],
  expandedRowIds: [],
};

export const createPenaltyLeadsInPenaltyCalculationTablesSlice: StateCreator<
  Store,
  [],
  [],
  PenaltyLeadsInPenaltyCalculationTablesSlice
> = (set, get) => ({
  penaltyLeadTables: initialState,
  addPenaltyLeadTable: (tableId) => {
    if (!(tableId in get().penaltyLeadTables)) {
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: leadsInPenaltyCalculationTableState,
        },
      }));
    }
  },
  getPenaltyLeadTableStateChangeFns: (tableId) => ({
    onSelectionChange: (selection) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], selection },
        },
      })),
    onColumnOrderChange: (columnOrder) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], columnOrder },
        },
      })),
    onColumnWidthsChange: (columnWidths) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], columnWidths },
        },
      })),
    onExpandedGroupsChange: (expandedGroups) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], expandedGroups },
        },
      })),
    onExpandedRowIdsChange: (expandedRowIds) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], expandedRowIds },
        },
      })),
    onFiltersChange: (filters) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], filters },
        },
      })),
    onGroupingChange: (grouping) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], grouping },
        },
      })),
    onHiddenColumnNamesChange: (hiddenColumnNames) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], hiddenColumnNames },
        },
      })),
    onSearchChange: (search) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], search },
        },
      })),
    onSortingChange: (sorting) =>
      set((state) => ({
        penaltyLeadTables: {
          ...state.penaltyLeadTables,
          [tableId]: { ...state.penaltyLeadTables[tableId], sorting },
        },
      })),
  }),
});
